<template>
  <div
    v-if="isTranslationLoading"
    class="fixed inset-0 bg-white bg-opacity-95 flex items-center justify-center z-50"
  >
    <div class="text-center">
      <PreloaderIcon class="mx-auto opacity-100 text-zuno-turquoise h-12 w-12" />
      <p class="text-sm text-theme-subtitle-grey pt-4">
        Loading translations...
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
const { isTranslationLoading } = useTranslationLoader()
</script>
